import React from 'react';
import classNames from 'classnames';
import styles from './css/index.module.scss';
import SchemeLayer from '../SchemeLayer';
import PlusIcon from '../../../../assets/icons/plusGray.svg';
import useSoundproofing from '../../../../hooks/useSoundproofing';
import useTranslations from '../../../../hooks/useTranslations';
import { DICTIONARY } from '../../../../translations/dictionary';
import SoundproofingServices from '../../../../services/SoundproofingServices';
import { SOUNDPROOFING_LAYER_SIZES, SOUNDPROOFING_LAYER_TYPES } from '../../../../constants/soundproofing';

function CompositionScheme() {
  const { t } = useTranslations();
  const {
    layers, selectedLayer, selectLayer, addLayers, removeLayer,
  } = useSoundproofing();

  const isAddButtonVisible = SoundproofingServices.canAddLayers(layers);
  return (
    <div className={classNames(styles.wrapper, 'blueHorizontalScroll')}>
      <div className={styles.scheme}>
        {layers.map((layer, index) => (
          <SchemeLayer
            key={layer.id}
            type={layer.type}
            label={layer.type === SOUNDPROOFING_LAYER_TYPES.glass
              ? t(DICTIONARY.soundproofingPage.glass)
              : t(DICTIONARY.soundproofingPage.spacerFrame)}
            isSelected={selectedLayer?.id === layer.id}
            isInactive={!!selectedLayer && selectedLayer.id !== layer.id}
            isFilled={SoundproofingServices.isLayerFilled(layer)}
            isRemovable={SoundproofingServices.canRemoveLayer(layers, index)}
            onClick={() => selectLayer(layer.id)}
            onRemoveClick={() => removeLayer(index)}
          />
        ))}

        {isAddButtonVisible && (
          <div className={classNames(styles.addColumn, { [styles.addColumnInactive]: !!selectedLayer })}>
            <div
              className={styles.addButton}
              style={{
                width: `${SOUNDPROOFING_LAYER_SIZES.addButton.width}px`,
                height: `${SOUNDPROOFING_LAYER_SIZES.addButton.height}px`,
              }}
              onClick={addLayers}
            >
              <img src={PlusIcon} alt="+" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CompositionScheme;
